import { Input } from '../../ui/Input/Input';
import { useState, useMemo } from 'react';
import { PrimaryButton } from '../../ui/Button/Buttons';
import { EMAIL_REGEX } from '../../../constants/Validation.constants';
import { authService } from '../../../services/AuthService';

type ForgotPasswordFormProps = {
  setIsSent: React.Dispatch<React.SetStateAction<boolean>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
};

export function ForgotPasswordForm({
  setIsSent,
  email,
  setEmail
}: ForgotPasswordFormProps) {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateEmail = (email: string) => {
    return EMAIL_REGEX.test(email);
  };

  const isEmailValid = useMemo(() => {
    return email.trim() !== '' && validateEmail(email);
  }, [email]);

  const handleSent = async () => {
    if (!email || !validateEmail(email)) return;

    try {
      setLoading(true);
      await authService.forgotPassword(email);
      setIsSent(true);
    } catch (error: any) {
      if (error) {
        console.error('Error sending reset password email:', error);
      }
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEmailChange = (value: string) => {
    setEmail(value);
    if (error) setError(false);
  };

  return (
    <form className="w-full">
      <div className="flex flex-col gap-6 self-stretch w-full">
        <div className="flex flex-col gap-2">
          <Input
            label="Email Address"
            id="email"
            type="email"
            required={true}
            value={email}
            maxLength={254}
            onChange={(e) => {
              handleEmailChange(e.target.value);
            }}
            labelClassName="label"
            inputClassName={`input ${
              error
                ? '!border-rose-400 !text-rose-800 !hover:border-rose-400 focus:!border-rose-400 focus:!ring-rose-700 focus-visible:!border-rose-400 focus-visible:!ring-rose-700'
                : ''
            }`}
          />
        </div>
        <PrimaryButton
          type="submit"
          className="w-full"
          disabled={!isEmailValid || loading}
          onClick={handleSent}
        >
          {loading ? 'Sending...' : 'Send Reset Link'}
        </PrimaryButton>
      </div>
    </form>
  );
}
